
import { ClusterService, EntityService } from '@/api/AuthService'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import waitingRoomModule from '@/store/modules/waitingRoom'

export const actions = {
  INITIALIZE_MODULE ({ commit, dispatch }, { authUser, authToken }) {
    commit('SET_LOADING', true)
    commit('SET_AUTH_TOKEN', authToken)
    commit('SET_LOGGED_USER', authUser)
    dispatch('LOAD_CLUSTERS')
    dispatch('SET_SERVICES', { services: authUser.services, entities: authUser.entities })
  },

  LOAD_CLUSTERS ({ commit }) {
    ClusterService.query()
      .then(clusters => commit('SET_CLUSTERS', clusters))
      .catch(errors => console.log('Error Loading Clusters -> ', errors))
  },

  LOAD_BUSINESS_PLANS ({ commit, state }) {
    if (!state.businessPlans.length) {
      EntityService.getBusinessPlans()
        .then(businessPlans => commit('SET_BUSINESS_PLANS', businessPlans))
        .catch(errors => console.log('Error Loading BusinessPlans -> ', errors))
    }
  },

  UPDATE_ENTITY ({ commit, state }, payload) {
    state.services.forEach(service => {
      let entityToUpdate = service.entities.find(e => e.id === payload.entityId)
      if (entityToUpdate) {
        commit('SET_SERVICE_ENTITY', { serviceId: service.id, data: { ...entityToUpdate, ...payload.entity } })
      }
    })
  },

  SET_SERVICES ({ commit, dispatch }, { services, entities }) {
    commit('SET_SERVICES', { services, entities })
    dispatch('SERVICES_LOADED')
  },

  SERVICES_LOADED ({ commit, dispatch }) {
    dispatch('REGISTER_DYNAMIC_MODULES')
    commit('SET_HAS_LOADED', true)
  },

  REGISTER_WAITING_ROOM_MODULE ({ commit, dispatch }, { moduleSlug, clinicalServiceId, clinicalServiceUrl }) {
    const moduleName = `waiting-room-${moduleSlug}`

    if (!this.hasModule(moduleName)) {
      this.registerModule(moduleName, waitingRoomModule)
      dispatch(`${moduleName}/INITIALIZE_MODULE`, { clinicalServiceId, clinicalServiceUrl })
      commit('ADD_DYNAMIC_MODULE', { moduleName })
    } else {
      console.log('module already registered', moduleName)
    }
  },

  REGISTER_DYNAMIC_MODULES ({ state, dispatch }) {
    state.services
      .filter(service => state.authClinicalServiceIds.includes(service.id))
      .forEach(authClinicalService => {
        dispatch('REGISTER_WAITING_ROOM_MODULE', {
          moduleSlug: authClinicalService.slug,
          clinicalServiceId: authClinicalService.id,
          clinicalServiceUrl: authClinicalService.url
        })
      })

    state.services
      .filter(service => state.evocallServiceIds.includes(service.id))
      .forEach(evocallService => {
        let waitingRoomModulesFromComponents = {}

        evocallService.components.forEach(component => {
          if (component.clinical_service) {
            const moduleSlug = component.clinical_service.slug
            if (!waitingRoomModulesFromComponents.hasOwnProperty(moduleSlug)) {
              waitingRoomModulesFromComponents[moduleSlug] = {
                moduleSlug,
                clinicalServiceId: component.clinical_service.id,
                clinicalServiceUrl: component.clinical_service.url
              }
            }
          }
        })

        Object.values(waitingRoomModulesFromComponents).forEach(waitingRoomModule => dispatch('REGISTER_WAITING_ROOM_MODULE', waitingRoomModule))
      })
  },

  UNREGISTER_DYNAMIC_MODULES ({ state }) {
    state.dynamicModules.forEach(moduleName => {
      if (this.hasModule(moduleName)) {
        this.unregisterModule(moduleName)
      }
    })
  },

  RECONNECT ({ state, dispatch }) {
    Array.from(state.dynamicModules)
      .filter(moduleName => moduleName.includes('waiting-room'))
      .forEach(moduleName => {
        dispatch(`${moduleName}/RELOAD_MODULE`)
      })
  },

  LOGOUT: function ({ state, commit, dispatch, getters }) {
    sessionStorage.clear()
    LocalStorageHelper.clear()

    dispatch('UNREGISTER_DYNAMIC_MODULES')
    dispatch('auth/USER_LOGGED_OUT')
    commit('SET_LOGGED_USER', null)
    commit('SET_HAS_LOADED', false)
  }
}
